import React from 'react'
import styles from './Callout.css'

const assetPrefix = process.env.ASSET_PREFIX || ''

interface CalloutProps {
  title: string
  message: string
}

export default function Callout ({ title, message }: CalloutProps) {
  return (
    <section className={styles.container}>
      <img
        src={`${assetPrefix}/static/alert-icon.svg`}
        className={styles.exclamation}
      />
      <div>
        <strong>{title}</strong>
        <p
          dangerouslySetInnerHTML={{
            __html: message
          }}
        />
      </div>
    </section>
  )
}
